import { IoChevronForward, IoClose } from "react-icons/io5";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Gtag } from "./Analytics";
import { rateChangePhase, RATE_CHANGE_NOTICE_PATH } from "../rateChange";

// 10/1料金改定の告知バナー（ホーム上部・2026-09-03）。
// - 〜9/30: 「10/1より料金改定」 / 10/1〜10/15: 「10/1より新料金になりました」（JSTで判定）
// - タップで 9/1 配信の公開おしらせ本文へ
// - 「×」で以後非表示（版ごとにlocalStorage保存・端末ごと。事前告知を閉じても事後告知は改めて出る）
const HIDE_KEY = { before: 'rate_change_banner_hidden_before', after: 'rate_change_banner_hidden_after' };

export const RateChangeBanner = ({ style = {} }) => {
  const phase = rateChangePhase();
  const [hidden, setHidden] = useState(() => {
    try { return !!phase && localStorage.getItem(HIDE_KEY[phase]) === '1'; } catch (e) { return false; }
  });
  if (!phase || hidden) return null;

  const hide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { localStorage.setItem(HIDE_KEY[phase], '1'); } catch (e2) { /* no-op */ }
    Gtag('rate_change_banner_close', { phase });
    setHidden(true);
  };

  return (
    <Link to={RATE_CHANGE_NOTICE_PATH} className="d-block" style={{ textDecoration: 'none', ...style }} onClick={() => Gtag('rate_change_banner_click', { phase })}>
      <div style={{ background: '#fff4e5', border: '1px solid #ffc773', borderRadius: 10, padding: '12px 14px', color: '#7a4a00', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ fontSize: 14, textAlign: 'left' }}>
          {phase === 'before' ? (
            <>📢 <b>10月1日より料金を改定します</b>。9/30までのご注文は現行料金です → 改定内容を見る</>
          ) : (
            <>📢 <b>10月1日より新料金になりました</b> → 改定内容を見る</>
          )}
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 'none' }}>
          <IoChevronForward />
          <IoClose onClick={hide} style={{ color: '#a86500', fontSize: 18 }} aria-label="この案内を閉じる" />
        </span>
      </div>
    </Link>
  );
};
